import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YangiKiaAvtomobillariniBizBilanTanlang() {
  return <section data-section-id="223597" id="ride-the-frontier" className="dark bg-background text-foreground relative min-h-[100dvh] flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_dawn_cinematic.png)] bg-cover bg-center bg-no-repeat" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-default font-light text-6xl sm:text-7xl lg:text-8xl tracking-tighter leading-tight mb-8 text-white">Ride the frontier</h1>
          
          <p className="font-default tracking-wide mb-12 max-w-2xl mx-auto !text-[26px] !bg-[rgba(0,0,0,0.11)] !text-[rgba(255,255,255,0.86)] !font-light">Small-group motorbike journeys through the Ha Giang Loop. A curated journey through Northern Vietnam</p>

          <div className="flex flex-col sm:flex-row gap-4 sm:items-center justify-center">
            <Button asChild size="lg" className="text-base h-14 px-12 py-6 rounded-sm bg-secondary text-secondary-foreground hover:bg-secondary/90 transition-all duration-500 hover:shadow-[0_0_20px_rgba(255,255,255,0.15)]">
              <Link to="https://frontiernorthvietnam.com/reserve-your-seat/">Reserve Your Seat</Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="text-base h-14 px-12 py-6 rounded-sm border-white/30 text-white hover:bg-white hover:text-background bg-transparent dark:border-white/30 dark:text-white dark:hover:bg-white dark:hover:text-background transition-colors duration-500">
              <Link to="/">Easy Rider experience</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center animate-bounce">
        <span className="sr-only">Scroll to explore</span>
        <ChevronDown className="size-8 text-white/40" aria-hidden="true" />
      </div>
    </section>;
}